import { useLocation } from '@reach/router';
import React, { useState } from 'react';
// local imports
import { deliveryOptionFormat } from 'utils/helpers';
import { STANDARD_SHIPPING } from 'utils/constants';

export const TestTakerPaymentContext = React.createContext<TestTakerContext>(null!);

export const TestTakerPaymentProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const state = location?.state as Partial<LocationState>;

  const defaultShippingMethod = state?.shippingMethods?.find((shippingMethod) => {
    return shippingMethod.id === STANDARD_SHIPPING;
  })

  const DEFAULT_SHIPPING_METHOD = deliveryOptionFormat(defaultShippingMethod!);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState(DEFAULT_SHIPPING_METHOD);

  const [lineItems, setLineItems] = useState(state?.lineItems!);

  const updateShippingMethod: TestTakerContext["updateShippingMethod"] = (shippingMethod) => {
    const method = shippingMethod ?? DEFAULT_SHIPPING_METHOD;

    setSelectedShippingMethod(method);
  };

  return (
    <TestTakerPaymentContext.Provider
      value={{
        updateShippingMethod,
        selectedShippingMethod,
        lineItems,
        setLineItems,
      }}
    >
      {children}
    </TestTakerPaymentContext.Provider>
  );
};
